import React from 'react';
import { Box } from '@mui/material';
import FilterChip from './FilterChip';
import { 
  ORGANIZATIONAL_STATUSES,
  getStatusText,
  getStatusColor,
  getStatusTextColor
} from '../../../constants/organizationalStatuses';

// Helper function to get border color (same as text color for consistency)
const getStatusBorderColor = (status) => {
  return getStatusTextColor(status);
};

const OrganizationalStatus = ({ 
  selectedStatuses = [], 
  onStatusToggle,
  sx = {} 
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', ...sx }}>
      {Object.values(ORGANIZATIONAL_STATUSES).map((status) => {
        const isSelected = selectedStatuses.includes(status);
        
        return (
          <FilterChip
            key={status}
            label={getStatusText(status)}
            isSelected={isSelected}
            onClick={() => onStatusToggle(status)}
            backgroundColor={getStatusColor(status)}
            textColor={getStatusTextColor(status)}
            borderColor={getStatusBorderColor(status)}
            showDot={true}
          />
        );
      })}
    </Box>
  );
};

export default OrganizationalStatus; 